import { render, staticRenderFns } from "./IzinGuncelle.vue?vue&type=template&id=3885362a&scoped=true&"
import script from "./IzinGuncelle.vue?vue&type=script&lang=js&"
export * from "./IzinGuncelle.vue?vue&type=script&lang=js&"
import style0 from "./IzinGuncelle.vue?vue&type=style&index=0&id=3885362a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3885362a",
  null
  
)

export default component.exports